import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  constructor(private route: ActivatedRoute, private router: Router) { }

  name: string = "LEILÕES";
  ngOnInit() {
  }



  escolhaLeilao(value: string){
    this.router.navigate([value], { relativeTo: this.route });
  }
}
